// iter414 — Data Entry Alerts card extracted from DashboardPage.jsx
// Surfaces "missing sales/expenses for today/yesterday" warnings, one
// row per (branch, missing_field). Today's gaps render in error red,
// older gaps in warning amber. Each row has an "Enter" jump-to button.
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function DataEntryAlertsCard({ alerts = [] }) {
  const navigate = useNavigate();
  if (!alerts.length) return null;
  return (
    <Card className="border-warning/30 bg-warning/10" data-testid="missing-data-alerts">
      <CardHeader className="pb-2">
        <CardTitle className="font-outfit flex items-center gap-2 text-warning text-base">
          <AlertCircle size={18} /> Data Entry Alerts
          <Badge className="bg-warning/20 text-warning text-xs ml-auto">
            {alerts.length} alerts
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {alerts.map((alert, i) => (
            <div
              key={`${alert.branch_name}-${alert.date}-${i}`}
              className={`flex items-center gap-3 p-3 rounded-lg border ${
                alert.is_today
                  ? 'bg-error/10 border-error/30'
                  : 'bg-warning/10 border-warning/30'
              }`}
            >
              <div
                className={`w-2 h-2 rounded-full flex-shrink-0 ${
                  alert.is_today ? 'bg-error animate-pulse' : 'bg-warning'
                }`}
              />
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm truncate">{alert.branch_name}</div>
                <div className="text-[11px] text-muted-foreground">
                  No <span className="font-semibold text-warning">{alert.missing.join(' or ')}</span>{' '}
                  for {alert.is_today ? 'today' : alert.date}
                </div>
              </div>
              <Button
                size="sm"
                variant="outline"
                className="h-7 text-xs shrink-0"
                onClick={() => navigate(alert.missing.includes('sales') ? '/sales' : '/expenses')}
                data-testid={`alert-action-${i}`}
              >
                Enter
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

export default DataEntryAlertsCard;
